export const FacilityProgram = {
  OUTPATIENT_SURGICAL: 1,
  OUTPATIENT_PROCEDURAL: 2,
  OUTPATIENT_ORAL_MAXILLOFACIAL: 3,
  OUTPATIENT_PEDIATRIC_DENTISTRY: 4,
  MEDICARE_SURGICAL: 5,
  MEDICARE_PHYSICAL_THERAPY: 6,
  MEDICARE_RURAL_HEALTH: 7,
  INTERNATIONAL_SURGICAL: 8,
  INTERNATIONAL_PHYSICAL_THERAPY: 9,
  INTERNATIONAL_DENTAL: 10,
  INTERNATIONAL_CLINIC_POLYCLINIC: 11,
  MEDSPA: 12,
};
